export default `
  query listChatLog($workflowId: ID!) {
    listChatLog(workflowId: $workflowId) {
      id
      workflowId
      type
      content
      userId
      aiOutput
      createdAt
    }
  }
`
